// extracted by mini-css-extract-plugin
module.exports = {"legend":"ChartLegend_legend__3JfTM"};